import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap, switchMap } from 'rxjs';
import { GlobalComponent } from 'src/app/global-component';
import { MyfileModel } from '../../models/myfile/myfile.model';
import { SearchResultModel } from '../../models/query/search-result-model';
import { AuthMyfileService } from '../auth.myfile.service';
import { MyfileApiService } from '../myfile-api.service';
import { BaseListService } from './base-list.service';
import { InvoiceSearchModel } from '../../models/commerce/invoice-search.model';
import { DocumentStatus } from '../../models/document/document-template-model';

@Injectable({
  providedIn: 'root'
})

export class InvoiceListService extends BaseListService {

  defaultInvoiceListState: InvoiceSearchModel = {
    sortColumnDirective: 'modifiedDate',
    sortDirectionDirective: 'desc',
    pageSize: GlobalComponent.defaultPagingInfo.pageSize,
    pageIndex: 0,
    startIndex: 0,
    sortColumn: 'modifiedDate',
    sortDirection: 'desc',
    searchTerm: '',
    to: undefined,
    from: undefined,
    rangeDate: undefined,
    createdById: undefined,
  };

  private _resultItems$ = new BehaviorSubject<MyfileModel[]>([]);
  protected override _state: InvoiceSearchModel = { ...this.defaultInvoiceListState };

  constructor(
    private authService: AuthMyfileService,
    private myFileApiService: MyfileApiService) {
    super();
    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      switchMap(() => this._search()),
      tap(() => this._loading$.next(false))
    ).subscribe((result: any) => {
      this._resultItems$.next(result.items);
      this._total$.next(result.count);
    });
  }

  get invoices$() { return this._resultItems$.asObservable(); }
  get rangeDate() { return this._state.rangeDate; };

  set createdById(createdById: any) { this._state.createdById = createdById }
  set rangeDate(rangeDate: any) { this._setDateSearch({ rangeDate }); }
  set status(status: DocumentStatus) { this._state.status = status; this._search$.next(); }

  //this type of search is used when setting data ranges using the calender dropdown. This type of range search is currently not used anywhere else so its left as part of this class for now. Refactor this function if need to use this method else where later. 
  protected _setDateSearch(patch: Partial<InvoiceSearchModel>) {
    Object.assign(this._state, patch);
    if (this._state.rangeDate) {
      if (this._state.rangeDate.to && this._state.rangeDate.from) {
        this._state.to = this._state.rangeDate.to;
        this._state.from = this._state.rangeDate.from;
        this._search$.next();
      } else {
        this._state.to = this._state.rangeDate.from + Date;
        this._state.from = this._state.rangeDate.from;
        this._search$.next();
      }
    } else {
      this._state.to = undefined;
      this._state.from = undefined;
      this._search$.next();
    }
  }

  protected _search(): Observable<SearchResultModel<MyfileModel> | undefined> {

    this.validateStartIndex();

    this._state.sortColumn = this.titleCaseWord(this._state.sortColumnDirective) as string;

    //validates and sets the correct date range on the state, from the model received on the the calender dropdown function from the Bootstrap component on the list. 
    if (this._state.rangeDate) {
      if (this._state.rangeDate.to) {
        this._state.to = this._state.rangeDate.to;
      } else {
        this._state.to = new Date(this._state.rangeDate.from.getTime() + (24 * 60 * 60 * 1000));
      }
      this._state.from = this._state.rangeDate.from;
    }

    return this.myFileApiService.getInvoices(this._state);
  }

  clearListService() {
    this._state = { ...this.defaultInvoiceListState };
    this._resultItems$.next(new Array<MyfileModel>());
    this._total$.next(0);
  }
}